import { CONTENT_KIND, CHILD_CONTENT_KIND } from "../academyConstants";

const KIND_INFO = {};
Object.entries(CONTENT_KIND).forEach(([type, kind]) => {
  const role = ["READING", "LISTENING", "SPEAKING"].includes(type) ? "parent" : "flat";
  KIND_INFO[kind] = { type, role };
});
Object.entries(CHILD_CONTENT_KIND).forEach(([parentType, kind]) => {
  KIND_INFO[kind] = { type: parentType, role: "child" };
});

// بيدور على العنصر جوه entries (نتيجة getSkillQuestions) بالـ kind والـ id.
// مستخدم لو صفحة التعديل اتفتحت من غير navigation state (رفرش، أو لينك مباشر).
export function findContentItem(entries, kind, id) {
  const info = KIND_INFO[kind];
  if (!info) return null;
  const numericId = Number(id);

  if (info.role !== "child") {
    return entries.find((e) => e.type === info.type && e.id === numericId) || null;
  }
  for (const parent of entries.filter((e) => e.type === info.type)) {
    const found = (parent.questions || []).find((q) => q.id === numericId);
    if (found) return found;
  }
  return null;
}